module.exports = "<p>\n  xls-viewer works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./public/app/common/xls-viewer/xls-viewer.component.html
// module id = ./public/app/common/xls-viewer/xls-viewer.component.html
// module chunks = main